/* eslint-disable @typescript-eslint/naming-convention */

export class IdentificationType {
    IdentificationTypeId: number;
    Name: string;
    Description: string;
    RegularExpression: string;
    DefaultQualifierEdifact: string;
    DefaultQualifierX12: string;
    Qualifiers?: IdentificationTypeQualifier[] = [];
    CreatedDate: Date;
    CreatedBy: number;
    UpdatedDate: Date;
    UpdatedBy: number;
}

export class IdentificationTypeQualifier {
    IdentificationTypeQualifiersId: number;
    IdentificationTypesId: number;
    Qualifier: string;

    constructor(identificationTypesId?: number) {
        if (identificationTypesId) {
            this.IdentificationTypesId = identificationTypesId;
        }
    }
}
